export const userProfileAPIUrls = {
  get: '/settings/profile',
  save: '/settings/profile/save',
  image: {
    store: '/image/user/store',
    delete: '/image/user/delete',
  },
} as const;
